import React from 'react';

/**
 * Error Boundary component to catch JavaScript errors in child components,
 * display a fallback UI, and log error information to the console.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({ error, errorInfo });
    
    // Log errors to console for debugging
    console.error('Error in React widget:', error);
    console.error('Component stack:', errorInfo?.componentStack || 'No stack info available');
    
    // You could also send this to a logging service
    if (window.CustomWidgetsErrorLog) {
      window.CustomWidgetsErrorLog(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="cw-p-4 cw-border cw-border-red-500 cw-bg-red-100 cw-text-red-700 cw-rounded-lg">
          <h3 className="cw-text-lg cw-font-bold cw-mb-2">Something went wrong</h3>
          <details className="cw-p-2 cw-bg-white cw-rounded cw-mb-2">
            <summary className="cw-cursor-pointer cw-font-medium">View error details</summary>
            <p className="cw-mt-2 cw-text-sm cw-font-mono cw-whitespace-pre-wrap cw-break-words">
              {this.state.error?.toString() || 'Unknown error'}
            </p>
            {this.state.errorInfo && (
              <pre className="cw-mt-2 cw-text-xs cw-bg-gray-100 cw-p-2 cw-overflow-auto cw-max-h-40">
                {this.state.errorInfo.componentStack}
              </pre>
            )}
          </details>
          <p className="cw-text-sm">
            This error is only visible in development mode and when WP_DEBUG is set to true.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;